import { MARKETPLACE_NAV_MENU_COMPONENT } from 'navigation-components/config';
import { useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useEffect, useCallback } from 'react';
import { GlobalToolbarButton } from './GlobalToolbarButton';
import { ICON_NAMES } from './GlobalToolbarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActivateMarketplaceNavMenuButton = ({
  ariaLabelKey,
  iconTitleKey
}) => {
  const {
    isOpen
  } = useComponentState(MARKETPLACE_NAV_MENU_COMPONENT);
  const {
    toggle
  } = useToggleComponent(MARKETPLACE_NAV_MENU_COMPONENT);

  // Preload handler that ensures content is loaded but not shown
  const preloadContent = useCallback(() => {
    if (!isOpen) {
      // Only preload if not already open
      toggle(false);
    }
  }, [toggle, isOpen]);

  // Click handler - use toggle without arguments to let it handle state internally
  const handleClick = useCallback(() => {
    toggle(); // Let the toggle function handle the state internally
  }, [toggle]);
  useEffect(() => {
    // Handle menu close when clicking outside or pressing escape
    const handleEvent = event => {
      const menuElement = document.getElementById('marketplace-nav-menu');
      const buttonElement = document.getElementById('hs-global-toolbar-marketplace-list-item');
      if (event instanceof MouseEvent && menuElement && !menuElement.contains(event.target) && buttonElement && !buttonElement.contains(event.target) || event instanceof KeyboardEvent && event.key === 'Escape') {
        if (isOpen) {
          toggle();
        }
      }
    };
    document.addEventListener('mousedown', handleEvent);
    document.addEventListener('keydown', handleEvent);
    return () => {
      document.removeEventListener('mousedown', handleEvent);
      document.removeEventListener('keydown', handleEvent);
    };
  }, [isOpen, toggle]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(GlobalToolbarButton, {
      id: "hs-global-toolbar-marketplace-list-item",
      "data-test-id": "hs-global-toolbar-marketplace-list-item",
      itemName: "Marketplace",
      iconName: ICON_NAMES.MARKETPLACE,
      onClick: handleClick,
      onFocus: preloadContent,
      onMouseDown: preloadContent,
      onMouseEnter: preloadContent,
      ariaLabelKey: ariaLabelKey,
      ariaExpanded: isOpen,
      ariaControls: "marketplace-nav-menu",
      iconTitleKey: iconTitleKey
    }), /*#__PURE__*/_jsx("div", {
      id: "marketplace-nav-menu"
    })]
  });
};